import { render, staticRenderFns } from "./OcrScorecardModal.vue?vue&type=template&id=3a92cdfa&scoped=true"
import script from "./OcrScorecardModal.vue?vue&type=script&lang=js"
export * from "./OcrScorecardModal.vue?vue&type=script&lang=js"
import style0 from "./OcrScorecardModal.vue?vue&type=style&index=0&id=3a92cdfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a92cdfa",
  null
  
)

export default component.exports